export class AvRuntimeManager {
    static async initialize(selectedGames) {
        if (this.initialized) {
            return;
        }
        const response = await fetch("./architecture.xml");
        if (!response.ok) {
            throw new Error(`Unable to load architecture.xml: ${response.status}`);
        }
        const architectureXml = await response.text();
        await window.AvRuntime.AvBundle.initialize({
            architectureXml,
            selectedGames,
        });
        this.initialized = true;
    }
    static async updateSelectedGames(selectedGames) {
        await window.AvRuntime.AvBundle.updateSelectedGames(selectedGames);
    }
    static async processRawGameSummaries(rawGameSummaries) {
        return window.AvRuntime.AvBundle.processRawGameSummaries(rawGameSummaries);
    }
}
AvRuntimeManager.initialized = false;
//# sourceMappingURL=AvRuntimeManager.js.map